import { useState, useEffect } from 'react';

/**
 * The state for an <ItemSelector />
 *
 * @example
 * selector = useSelector(array, initialId)
 * <ItemSelector {...selector} />
 */
export function useSelector(source, selectedId, options) {
  const [items, setItems] = useState(source);
  const [value, setValue] = useState(selectedId);

  useEffect(() => {
    if (items !== source) setItems(source);
  }, [source, items]);

  return Object.assign(
    {
      items,
      value,
      onChange: setValue,
    },
    options,
  );
}

export function validateSelectorValue(selector, options) {
  const validValues = options.map(option => option.id);
  if (selector && selector.value && validValues.includes(selector.value)) {
    return selector.value;
  }
}
